import { useGetModelsByRunForProject } from "modules/projects/api";

import * as flowConfig from "./config";
import { MarketMixModellingProject } from "./interfaces";

export const getDataFileId = (project: MarketMixModellingProject) =>
  project.data_files[flowConfig.INPUT_DATA];

export const getTargetVariable = (project: MarketMixModellingProject) =>
  project.meta_data[flowConfig.TARGET_VAR_KEY];

export const getTimeVariable = (project: MarketMixModellingProject) =>
  project.meta_data[flowConfig.TIMESTAMP_VAR_KEY];

export const getGroupingVariables = (project: MarketMixModellingProject) =>
  project.meta_data[flowConfig.GROUPING_VARS_KEY] || [];

export const useGetModelsByRun = (project: MarketMixModellingProject) =>
  useGetModelsByRunForProject(
    project,
    flowConfig.RUN_ID,
    flowConfig.TIME_STAMP
  );
